import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { actions } from '../../modules/Actions';
import { CommodityCategoryContractInfo } from '../../../external/AggregationApi';

export const initialSearchBranchCommodityCategoryContract: CommodityCategoryContractInfo = {
  smartphoneNew: '',
  smartphoneChange: '',
  smartphoneMnp: '',
  smartphoneContrChg: '',
  garakeiNew: '',
  garakeiChange: '',
  garakeiMnp: '',
  garakeiContrChg: '',
  tabletNew: '',
  tabletChange: '',
  tabletMnp: '',
  tabletContrChg: '',
  otherNew: '',
  otherChange: '',
  otherMnp: '',
  otherContrChg: '',
  hikariNew: '',
  hikariDiverted: '',
  hikariChange: '',
  hikariReuse: '',
  auroraNew: '',
  auroraSrvChgHikari: '',
  auroraSrvChgAir: '',
  auroraReUseHikari: '',
  auroraSrvChgBbisp: '',
  airNew: '',
  airChange: '',
  denwaNew: '',
  denkiNew: '',
  simNew: '',
  simTransfer: '',
  simChange: '',
  simMnp: '',
  simContrCh: '',
  dataBoxNew: '',
  basketLiveNew: '',
  smartphoneSetSupportNew: '',
};

export const searchBranchCommodityCategoryContractReducer = reducerWithInitialState(initialSearchBranchCommodityCategoryContract).case(
  actions.updateSearchBranch.commodityCategoryContract,
  (state: CommodityCategoryContractInfo, payload: CommodityCategoryContractInfo) => {
    return {
      ...state,
      ...payload,
    };
  }
);
